var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { cPointAtOrigin, classNames, entityTypeNameFor } from '@shapeable/utils';
import { SvgCanvas, useLink, usePageEntity, useThemeEval } from '@shapeable/ui';
import { flatten, filter, sortBy, get, includes } from 'lodash';
import { ChartRing } from './chart-ring';
var cls = classNames('radar-chart');
import { animated, useSpring, to } from '@react-spring/web';
import { sum, keyBy, mapValues } from 'lodash';
import { TopicNode } from '../entities/topic-node';
import { TrendArcButton } from '../entities/trend-arc-button';
import { useTrendsRadar } from '../context/trends-radar-context';
export var RadarChartDefaultProps = {
  padding: 4,
  ringCount: 27,
  ringGap: 15,
  isInteractive: true,
  valuesDelay: 150,
  tabRadius: 30,
  minValueOffset: 5,
  innerRingRadius: 50,
  initialAngle: 130,
  rangeBuffer: 10,
  innerPadding: 5,
  trendArcWidth: 30,
  springConfig: {
    duration: 500
  },
  angleStartDelta: 25,
  initialZoom: 1.0
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n\t"], ["\n    width: 100%;\n    height: 100%;\n\t"])))
});
var RingStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\n\t"], ["\n\n\t"])))
});
var ShapeStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TrendStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n\n    ", "\n  "], ["\n    ", ";\n\n    ", "\n  "])), theme.TRANSITION('opacity'), function (_a) {
    var isInteractive = _a.isInteractive;
    return isInteractive && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      &:hover {\n        opacity: 1 !important;\n      }\n    "], ["\n      &:hover {\n        opacity: 1 !important;\n      }\n    "])));
  })
});
var TopicStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled(SvgCanvas)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Ring: styled(ChartRing)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), RingStyles),
  Shape: styled(animated.polygon)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ShapeStyles),
  Trend: styled(animated(TrendArcButton))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), TrendStyles),
  Topic: styled(TopicNode)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), TopicStyles)
};
var entityOutlineNumberRank = function (item) {
  var _a;
  if (!item.outlineNumber) return 0;
  var parts = (_a = item.outlineNumber) === null || _a === void 0 ? void 0 : _a.split('.');
  var rank = parts.reduce(function (acc, val, i) {
    var multiplier = Math.pow(10, (parts.length - 1 - i) * 2);
    return acc + parseInt(val, 10) * multiplier;
  }, 0);
  return rank;
};
export var RadarChart = function (props) {
  var e_1, _a;
  var className = props.className,
    children = props.children,
    initialViewBox = props.initialViewBox,
    fadeSize = props.fadeSize,
    isInteractive = props.isInteractive,
    ringGap = props.ringGap,
    ringCount = props.ringCount,
    springConfig = props.springConfig,
    valuesDelay = props.valuesDelay,
    minValueOffset = props.minValueOffset,
    trendArcWidth = props.trendArcWidth,
    innerRingRadius = props.innerRingRadius,
    tabRadius = props.tabRadius,
    initialAngle = props.initialAngle,
    padding = props.padding,
    rangeBuffer = props.rangeBuffer,
    angleStartDelta = props.angleStartDelta,
    innerPadding = props.innerPadding,
    animate = props.animate,
    initialZoom = props.initialZoom,
    initialY = props.initialY,
    bottomFadeSize = props.bottomFadeSize,
    topFadeSize = props.topFadeSize,
    leftFadeSize = props.leftFadeSize,
    rightFadeSize = props.rightFadeSize;
  var trends = sortBy(useTrendsRadar(), entityOutlineNumberRank);
  var outerRingRadius = innerRingRadius + (ringCount - 1) * ringGap;
  var width = (outerRingRadius + tabRadius + trendArcWidth + padding) * 2;
  var height = width;
  var topicCount = sum(trends.map(function (trend) {
    var _a;
    return ((_a = trend.topics) === null || _a === void 0 ? void 0 : _a.length) || 0;
  }));
  var origin = {
    x: width / 2,
    y: height / 2
  };
  var navigate = useLink().navigate;
  var onTrendClick = function (trend) {
    navigate(trend.path);
  };
  var onTopicClick = function (topic) {
    navigate(topic.path);
  };
  var entity = usePageEntity();
  var currentEntityTypeName = entityTypeNameFor(entity);
  var highlightActiveNode = includes(['Topic', 'Trend'], currentEntityTypeName);
  var shapePointScaleFactor = outerRingRadius - innerRingRadius - minValueOffset - rangeBuffer - ringGap * 2;
  var cPoint = cPointAtOrigin(origin.x, origin.y);
  var dotGapAngle = 360 / topicCount;
  var allTopics = sortBy(flatten(trends.map(function (trend) {
    return filter(trend.topics.map(function (topic) {
      var _a;
      var anticipationPotentialIndicator = (_a = topic.indicatorValues) === null || _a === void 0 ? void 0 : _a.find(function (indicatorValue) {
        return (indicatorValue === null || indicatorValue === void 0 ? void 0 : indicatorValue.indicator.dataSetId) === 'ANTICIPATION_POTENTIAL';
      });
      if (!anticipationPotentialIndicator) return null;
      var anticipationPotentialValue = anticipationPotentialIndicator.numericValue;
      return __assign(__assign({}, topic), {
        anticipationPotentialValue: anticipationPotentialValue
      });
    }));
  })), entityOutlineNumberRank);
  var highlightedTopics = [];
  if (currentEntityTypeName === 'Topic') {
    highlightedTopics = [entity.id];
  }
  if (currentEntityTypeName === 'Trend') {
    highlightedTopics = allTopics.filter(function (topic) {
      var _a;
      return ((_a = topic.trend) === null || _a === void 0 ? void 0 : _a.id) === entity.id;
    }).map(function (topic) {
      return topic.id;
    });
  }
  if (currentEntityTypeName === 'SubTopic') {
    highlightedTopics = filter([get(entity, 'topic.id', '')]);
  }
  var highlightedTrends = currentEntityTypeName === 'Trend' ? [entity.id] : currentEntityTypeName === 'Topic' ? allTopics.filter(function (topic) {
    return topic.id === entity.id;
  }).map(function (topic) {
    var _a;
    return (_a = topic.trend) === null || _a === void 0 ? void 0 : _a.id;
  }) : currentEntityTypeName === 'SubTopic' ? allTopics.filter(function (topic) {
    var _a;
    return (_a = topic.subTopics) === null || _a === void 0 ? void 0 : _a.find(function (subTopic) {
      return subTopic.id === entity.id;
    });
  }).map(function (topic) {
    var _a;
    return (_a = topic.trend) === null || _a === void 0 ? void 0 : _a.id;
  }) : [];
  // if (currentEntityTypeName === 'Page') {
  //   /* @ts-ignore */
  //   highlightedTrends = compact([entity.trend?.id]);
  //   if (highlightedTrends.length) {
  //     /* @ts-ignore */
  //     highlightedTopics = allTopics.filter(topic => highlightedTrends.includes(topic.trend?.id)).map(topic => topic.id);
  //   }
  // } 
  var minValue = Math.min.apply(Math, __spreadArray([], __read(allTopics.map(function (topic) {
    return topic.anticipationPotentialValue;
  })), false));
  var maxValue = Math.max.apply(Math, __spreadArray([], __read(allTopics.map(function (topic) {
    return topic.anticipationPotentialValue;
  })), false));
  var range = maxValue - minValue;
  var topicNodes = allTopics.map(function (topic, i) {
    var angle = initialAngle + i * dotGapAngle;
    var radius = minValueOffset + innerRingRadius + rangeBuffer - innerPadding + (topic.anticipationPotentialValue - minValue) / range * shapePointScaleFactor;
    var isActive = highlightedTopics.length === 0 || includes(highlightedTopics, topic.id);
    return __assign(__assign(__assign({}, cPoint(radius, angle)), topic), {
      radius: radius,
      angle: angle,
      isActive: isActive
    });
  });
  var trendDefinitions = [];
  var trendStartAngle = initialAngle - dotGapAngle / 2;
  try {
    for (var trends_1 = __values(trends), trends_1_1 = trends_1.next(); !trends_1_1.done; trends_1_1 = trends_1.next()) {
      var trend = trends_1_1.value;
      var tailAngle = trendStartAngle;
      var headAngle = trendStartAngle + trend.topics.length * dotGapAngle;
      trendDefinitions.push(__assign({
        headAngle: headAngle,
        tailAngle: tailAngle
      }, trend));
      trendStartAngle = headAngle;
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (trends_1_1 && !trends_1_1.done && (_a = trends_1.return)) _a.call(trends_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  ;
  var RING_WIDTHS = {
    "9": 4,
    "18": 7
  };
  var topicsByIdAngle = keyBy(topicNodes, function (node) {
    return "angle-".concat(node.id);
  });
  var topicsByIdRadius = keyBy(topicNodes, function (node) {
    return "radius-".concat(node.id);
  });
  var duration = get(springConfig, 'duration', 600);
  var isAnimated = animate && (duration || valuesDelay);
  var shapeTo = __assign(__assign(__assign({}, mapValues(topicsByIdRadius, function (node) {
    return node.radius;
  })), mapValues(topicsByIdAngle, function (node) {
    return node.angle;
  })), {
    opacity: 1
  });
  var shapeValues = isAnimated ? useSpring({
    from: __assign(__assign(__assign({}, mapValues(topicsByIdRadius, function (node) {
      return 0;
    })), mapValues(topicsByIdAngle, function (node) {
      return node.angle - angleStartDelta;
    })), {
      opacity: 0
    }),
    to: shapeTo,
    config: springConfig,
    delay: valuesDelay
  }) : shapeTo;
  var trendValues = animate && duration ? useSpring({
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    },
    duration: duration,
    delay: valuesDelay
  }) : {
    opacity: 1
  };
  var shapePoints = function () {
    var coords = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      coords[_i] = arguments[_i];
    }
    var angleBase = coords.length / 2;
    var radiusValues = coords.slice(0, angleBase);
    var angleValues = coords.slice(angleBase);
    return radiusValues.map(function (value, i) {
      var radius = value;
      var angle = angleValues[i];
      var point = cPoint(radius, angle);
      return "".concat(point.cx, ",").concat(point.cy);
    }).join(' ');
  };
  var $ = useThemeEval();
  var shapeFill = $(theme.COLOR('verySubtle'));
  return React.createElement(My.Container, {
    isInteractive: isInteractive,
    fadeSize: fadeSize,
    bottomFadeSize: bottomFadeSize,
    topFadeSize: topFadeSize,
    leftFadeSize: leftFadeSize,
    rightFadeSize: rightFadeSize,
    initialViewBox: initialViewBox,
    initialY: initialY,
    initialZoom: initialZoom,
    width: width,
    height: height,
    className: cls.name(className)
  }, React.createElement(My.Shape, {
    style: {
      opacity: shapeValues.opacity
    },
    points: to(Object.values(shapeValues).slice(0, -1), shapePoints),
    fill: shapeFill,
    stroke: "none"
  }), Array.from({
    length: ringCount
  }).map(function (_, i) {
    var radius = 62 + i * ringGap;
    return React.createElement(My.Ring, {
      index: i,
      animate: animate,
      initialAngle: initialAngle,
      key: "ring-".concat(i),
      ringWidth: RING_WIDTHS[i.toString()] || 1,
      cx: origin.x,
      cy: origin.y,
      radius: radius,
      dotCount: topicCount,
      springConfig: springConfig
    });
  }), trendDefinitions.map(function (trend, i) {
    return React.createElement(My.Trend, {
      isInteractive: !!onTrendClick,
      style: {
        opacity: trendValues.opacity
      },
      onClick: isInteractive ? onTrendClick : null,
      isActive: highlightedTrends.length === 0 || includes(highlightedTrends, trend.id),
      originX: origin.x,
      originY: origin.y,
      key: "trend-".concat(i),
      entity: trend,
      innerRadius: outerRingRadius,
      outerRadius: outerRingRadius + 30,
      headAngle: trend.headAngle,
      tailAngle: trend.tailAngle,
      id: trend.id
    });
  }), topicNodes.map(function (node, i) {
    return React.createElement(My.Topic, {
      onClick: isInteractive ? onTopicClick : null,
      index: i,
      animate: animate,
      isActive: node.isActive,
      springConfig: springConfig,
      delay: valuesDelay,
      originX: origin.x,
      originY: origin.y,
      radiusStart: 0,
      radius: node.radius,
      angleStart: node.angle - angleStartDelta,
      angle: node.angle,
      key: "topic-".concat(i),
      entity: node
    });
  }), children);
};
RadarChart.cls = cls;
RadarChart.defaultProps = RadarChartDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;